import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Globe2 } from "lucide-react";
import { useToast } from "../../components/Toast";

type Peer = { id: string; name: string; address: string; apps: number };

const PEERS: Peer[] = [
  { id: "spb-01", name: "Санкт-Петербург · ЦО",  address: "10.20.10.11", apps: 124 },
  { id: "spb-02", name: "Санкт-Петербург · ф-2", address: "10.20.20.11", apps: 92 },
];

export default function LocationPage() {
  const navigate = useNavigate();
  const push = useToast();
  const [selected, setSelected] = useState<string>("spb-01");

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-2 px-4 pb-2 pt-2">
        <button
          onClick={() => navigate("/client")}
          className="grid h-9 w-9 place-items-center rounded-full text-[var(--color-fg-muted)] hover:bg-[var(--color-surface-2)]"
          aria-label="Назад"
        >
          <ChevronDown size={20} />
        </button>
        <h1 className="text-[18px] font-semibold tracking-[-0.005em] text-[var(--color-fg)]">Локация</h1>
      </div>

      <div className="flex-1 overflow-y-auto px-4 pb-6">
        {/* Информационный баннер */}
        <div className="flex items-start gap-3 rounded-2xl border border-[var(--color-warning)]/30 bg-[var(--color-warning-bg)] p-3">
          <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-[var(--color-warning)] text-white">
            <Globe2 size={15} />
          </span>
          <div className="text-[12.5px]">
            <div className="font-semibold text-[var(--color-fg)]">Подключиться к другой локации</div>
            <div className="mt-0.5 text-[var(--color-fg-muted)]">
              Ваш домашний сервер недоступен. Маркет обнаружил соседний Локальный сервер.
            </div>
          </div>
        </div>

        <h2 className="mt-5 text-[10.5px] font-medium uppercase tracking-[0.08em] text-[var(--color-fg-muted)]">
          Найдено в текущей сети
        </h2>
        <ul className="mt-2 space-y-2">
          {PEERS.map((p) => (
            <li key={p.id}>
              <PeerRow peer={p} active={selected === p.id} onSelect={() => setSelected(p.id)} onConnect={() => {
                push({ kind: "success", text: `Подключено к ${p.id}` });
                navigate("/client");
              }} />
            </li>
          ))}
        </ul>

        <p className="mt-5 text-[11.5px] leading-relaxed text-[var(--color-fg-muted)]">
          Вход выполняется по тем же логину и паролю. Доступны приложения, разрешённые вашей группе.
        </p>
      </div>
    </div>
  );
}

function PeerRow({
  peer,
  active,
  onSelect,
  onConnect,
}: {
  peer: Peer;
  active: boolean;
  onSelect: () => void;
  onConnect: () => void;
}) {
  return (
    <div
      onClick={onSelect}
      className={
        "flex items-center gap-3 rounded-2xl border p-3 transition-colors " +
        (active
          ? "border-[var(--color-brand)] bg-[var(--color-brand)]/5"
          : "border-[var(--color-border)] bg-[var(--color-surface)]")
      }
    >
      <span className="h-2 w-2 rounded-full bg-[var(--color-success)]" />
      <div className="min-w-0 flex-1">
        <div className="font-mono text-[13px] font-medium text-[var(--color-fg)]">{peer.id}</div>
        <div className="text-[11px] text-[var(--color-fg-muted)]">{peer.name}</div>
        <div className="mt-0.5 font-mono text-[10.5px] text-[var(--color-fg-faint)]">{peer.address} · {peer.apps} приложений</div>
      </div>
      <button
        onClick={(e) => { e.stopPropagation(); onConnect(); }}
        className={
          "shrink-0 rounded-full px-3 py-1.5 text-[12px] font-medium transition-colors " +
          (active
            ? "bg-[var(--color-brand)] text-white"
            : "border border-[var(--color-border-strong)] text-[var(--color-fg)]")
        }
      >
        Подключиться
      </button>
    </div>
  );
}
